import { Eye, EyeOff, Loader2 } from 'lucide-react'
import { cn, Switch, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@teach/ui'

interface Props {
  id?: string
  label: string
  /** Что значит текущее положение: виден ученикам или скрыт. */
  hint: string
  checked: boolean
  disabled?: boolean
  /** Ждём сервер: в кружке загрузка вместо глаза. */
  pending?: boolean
  /** Крупный вариант для настроек курса. */
  large?: boolean
  onCheckedChange: (next: boolean) => void
}

/** Тумблер показа языка ученикам: глаз в кружке, чтобы не читался как удаление языка. */
export const VisibilitySwitch = ({
  id,
  label,
  hint,
  checked,
  pending = false,
  large = false,
  ...rest
}: Props) => {
  const Icon = pending ? Loader2 : checked ? Eye : EyeOff
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="relative inline-flex">
            <Switch
              id={id}
              aria-label={label}
              checked={checked}
              className={
                large
                  ? 'h-7 w-[3.25rem] [&>span]:size-6 [&>span]:data-[state=checked]:translate-x-6'
                  : undefined
              }
              {...rest}
            />
            {/* Значок едет вместе с кружком. Сдвиг — на обёртке: `animate-spin` занимает `transform`
                самого значка и сбросил бы сдвиг. */}
            <span
              aria-hidden
              className={cn(
                'pointer-events-none absolute flex transition-transform',
                large ? 'left-[7px] top-[7px]' : 'left-1.5 top-1.5',
                checked && (large ? 'translate-x-6' : 'translate-x-5'),
              )}
            >
              <Icon
                className={cn(
                  large ? 'size-3.5' : 'size-3',
                  checked ? 'text-brand' : 'text-muted-foreground',
                  pending && 'animate-spin',
                )}
              />
            </span>
          </span>
        </TooltipTrigger>
        <TooltipContent>{hint}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
